var map = {
	"./Icon24Fill15Decrease.svg": [
		848,
		163
	],
	"./Icon24Fill15Increase.svg": [
		849,
		164
	],
	"./Icon24FillAfisha.svg": [
		873,
		165
	],
	"./Icon24FillArrowBottom.svg": [
		855,
		0
	],
	"./Icon24FillArrowLeft.svg": [
		827,
		2
	],
	"./Icon24FillArrowRight.svg": [
		828,
		4
	],
	"./Icon24FillArrowTop.svg": [
		854,
		1
	],
	"./Icon24FillBonuses.svg": [
		876,
		210
	],
	"./Icon24FillBusiness.svg": [
		834,
		166
	],
	"./Icon24FillCalendar.svg": [
		866,
		16
	],
	"./Icon24FillCalories.svg": [
		867,
		167
	],
	"./Icon24FillCertificate.svg": [
		869,
		168
	],
	"./Icon24FillCity.svg": [
		863,
		25
	],
	"./Icon24FillClock.svg": [
		852,
		12
	],
	"./Icon24FillClose.svg": [
		844,
		7
	],
	"./Icon24FillComments.svg": [
		872,
		169
	],
	"./Icon24FillComplexity.svg": [
		877,
		170
	],
	"./Icon24FillDistance.svg": [
		858,
		8
	],
	"./Icon24FillDot.svg": [
		874,
		26
	],
	"./Icon24FillEdit.svg": [
		830,
		5
	],
	"./Icon24FillEmail.svg": [
		831,
		17
	],
	"./Icon24FillExcursion.svg": [
		865,
		27
	],
	"./Icon24FillExit.svg": [
		875,
		28
	],
	"./Icon24FillFacebook.svg": [
		839,
		29
	],
	"./Icon24FillFavorites.svg": [
		850,
		13
	],
	"./Icon24FillInfo.svg": [
		860,
		30
	],
	"./Icon24FillInstagram.svg": [
		838,
		31
	],
	"./Icon24FillInvalid.svg": [
		851,
		32
	],
	"./Icon24FillLanguages.svg": [
		868,
		171
	],
	"./Icon24FillLoading.svg": [
		829,
		18
	],
	"./Icon24FillLocation.svg": [
		864,
		10
	],
	"./Icon24FillMagazine.svg": [
		878,
		211
	],
	"./Icon24FillMinus.svg": [
		879,
		33
	],
	"./Icon24FillOk.svg": [
		836,
		34
	],
	"./Icon24FillOkay.svg": [
		880,
		19
	],
	"./Icon24FillPause.svg": [
		847,
		172
	],
	"./Icon24FillPhone.svg": [
		832,
		20
	],
	"./Icon24FillPlay.svg": [
		846,
		21
	],
	"./Icon24FillPlus.svg": [
		870,
		6
	],
	"./Icon24FillPromo.svg": [
		881,
		212
	],
	"./Icon24FillRefresh.svg": [
		871,
		35
	],
	"./Icon24FillSearch.svg": [
		845,
		14
	],
	"./Icon24FillSeasons.svg": [
		861,
		173
	],
	"./Icon24FillSettings.svg": [
		857,
		174
	],
	"./Icon24FillShopping.svg": [
		882,
		213
	],
	"./Icon24FillStar.svg": [
		883,
		214
	],
	"./Icon24FillStop.svg": [
		862,
		175
	],
	"./Icon24FillTelegram.svg": [
		841,
		36
	],
	"./Icon24FillTickets.svg": [
		853,
		176
	],
	"./Icon24FillTiktok.svg": [
		840,
		37
	],
	"./Icon24FillTrash.svg": [
		843,
		3
	],
	"./Icon24FillTravel.svg": [
		884,
		215
	],
	"./Icon24FillUser.svg": [
		885,
		216
	],
	"./Icon24FillVk.svg": [
		835,
		38
	],
	"./Icon24FillWeb.svg": [
		833,
		15
	],
	"./Icon24FillYoutube.svg": [
		837,
		39
	],
	"./Icon24StrokeCheck.svg": [
		856,
		177
	],
	"./Icon24StrokeCheckboxArrow.svg": [
		886,
		178
	],
	"./Icon24StrokeFavorites.svg": [
		842,
		9
	],
	"./Icon36StrokeStar.svg": [
		859,
		179
	],
	"./Icon48FillCircleFacebook.svg": [
		887,
		217
	],
	"./Icon48FillCircleInstagram.svg": [
		888,
		218
	],
	"./Icon48FillCircleOk.svg": [
		889,
		219
	],
	"./Icon48FillCircleTelegram.svg": [
		890,
		220
	],
	"./Icon48FillCircleTiktok.svg": [
		891,
		221
	],
	"./Icon48FillCircleVk.svg": [
		892,
		222
	],
	"./Icon48FillCircleYoutube.svg": [
		893,
		223
	],
	"./LogotypeRosatom.svg": [
		894,
		224
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 422;
module.exports = webpackAsyncContext;